export const issueRole = {
  Innheimtutengilidir: 'Innheimtutengilidir',
  Greidendathjonusta: 'Greidendathjonusta',
  Personuvernd: 'Personuvernd',
};
